module.exports = __webpack_public_path__ + "9a5bda4d22d8db48509add286b5cd013.svg";